(function () {
    /** @ngInject */
    function timePageController($scope, $http, $state, Booking, $document, $timeout) {
        //var _last_timelist = [];
        $scope.checkWaitlist = false;
        $scope.canSeeAlternateRests = false;
        $scope.canSeeNext30Days = false;
        var meal_type = '';
        var activeIndex = getActiveCalendar();
        $scope.time_view = 'timelist';
        $scope.next_availibility = [];
        var _next_list_dates = { from: null, to: null };
        $scope.labels = {};
        $scope.canViewNext30 = settings.external_next30 === 'Y' && !($scope.booking.meal.type == 11 && $scope.booking.meal.type_alt > 0);
        $scope.alt_meal = {};
        $scope.full_text = {};
        var waitlist_full = [];
        $scope.too_late = {};
        $scope.stop_time = {};
        $scope.linked_timelist = [];
        $scope.full_text_labels = {};
        var short_length_av = {};
        var seating_lengths = [];
        $scope.activeLabel = false;
        $scope.activeLabelIndex = -1;
        $scope.labelList = [];
        var custom_length = false;
        $scope.show_linked_opt = false;
        var isToday = $scope.booking.getDate('YYYY-MM-DD') === moment.tgz().format('YYYY-MM-DD');
        var time_now = moment.tgz().format('HH:mm').replace(':', '');
        $scope.hasStopSize = function () {
            return _.size($scope.stop_time) || _.size($scope.too_late) ? true : false;
        };
        $scope.debugTimeList = function (time, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            updateWidgetStep('Timelist-Debug', { averageValue: $scope.booking.meal.avg_gtm_price, totalValue: ($scope.booking.meal.avg_gtm_price * $scope.booking.amount), meal: $scope.booking.meal.name, mealId: $scope.booking.meal.id, time: time, amount: $scope.booking.amount, date: $scope.booking.getDate('YYYY-MM-DD') });
            return false;
        };
        $scope.waitlistFull = function (time) {
            return _.includes(waitlist_full, time);
        };
        $scope.getTimeLabel = function (time) {
            if ($scope.waitlistFull(time)) {
                return $scope.full_text_labels['type_9'];
            }
            var label = $scope.full_text_labels['type_2'];
            if (_.has($scope.too_late, time)) {
                return $scope.full_text_labels['type_3'];
            }
            if (_.has($scope.stop_time, time)) {
                return $scope.stopTimeLabel();
            }
            return label;
        };

        $scope.printLabel = function (lbl, hideDefault) {
            return lbl === 'No Category' ? (hideDefault === true ? '' : no_cat_label) : lbl;
        };
        $scope.getShortLengthLabel = function (time) {
            if (!_.isEmpty(short_length_av) && _.has(short_length_av, time[0]))
                return (language === 'en' ? ' Available until' : ' Tillgängligt till') + ' ' + moment.tgz((time[1] * 1000) + (short_length_av[time[0]] * 60000)).format('HH:mm');
            return '';
        }
        $scope.stopTimeLabel = function () {
            return $scope.full_text_labels['type_4'].replace('{MEAL_NAME}', $scope.booking.meal.name).replace('{STOP_TIME}', $scope.booking.meal.books_after);
        }
        $scope.isVisibleTime = function (time) {
            if ($scope.isAvailableTime(time)) return true;
            if (waitlist !== 'Y') return false;
            return !isToday || _.parseInt(time_now) <= _.parseInt(time.replace(':', ''));
        };
        $scope.haveDailyComment = function () {
            return _.has(daily_comments, $scope.booking.date.format("YYYY-MM-DD"));
        };
        $scope.getDailyMessage = function () {
            return daily_comments[$scope.booking.date.format("YYYY-MM-DD")];
        };
        $scope.isTooLate = function (t) {
            return _.has($scope.too_late, t) || _.has($scope.stop_time, t);
        };
        $scope.getFullDayText = function () { return full_day_text; };
        $scope.seating_times = {
            30: "30 m",
            45: "45 m",
            60: "1h 00m",
            75: "1h 15m",
            90: "1h 30m",
            105: "1h 45m",
            120: "2h 00m",
            135: "2h 15m",
            150: "2h 30m",
            165: "2h 45m",
            180: "3h 00m",
            195: "3h 15m",
            210: "3h 30m",
            225: "3h 45m",
            240: "4h 00m",
            255: "4h 15m",
            270: "4h 30m",
            285: "4h 45m",
            300: "5h 00m",
            315: "5h 15m",
            330: "5h 30m",
            345: "5h 45m",
            360: "6h 00m",
            375: "6h 15m",
            390: "6h 30m",
            405: "6h 45m",
            420: "7h 00m",
            435: "7h 15m",
            450: "7h 30m",
            465: "7h 45m",
            480: "8h 00m",
            540: '9h 00m',
            600: '10h 00m',
            660: '11h 00m',
            720: '12h 00m',
            780: '13h 00m',
            840: '14h 00m',
            900: '15h 00m',
            960: '16h 00m',
            1020: '17h 00m',
            1080: '18h 00m',
            1140: '19h 00m',
            1200: '20h 00m',
            1260: '21h 00m',
            1320: '22h 00m',
            1380: '23h 00m',
            1440: '1d',
            2880: '2d',
            4320: '3d',
            5760: '4d',
            7200: '5d',
            8640: '6d',
            10080: '7d'
        };
        $scope.alternateMealAvailable = function () {
            return settings.alternate_meals !== false && _.size(settings.alternate_meals) > 0 && _.find(settings.alternate_meals, { from_mealid: $scope.booking.mealid });
        };
        $scope.checkAlternateMeal = function () {
            if (_.has($scope.alt_meal, 'id')) {
                $scope.booking.setMeal($scope.alt_meal);
            }
            _initTime();
        };
        $scope.isWaitList = function (time) {
            return waitlist === 'Y' && !$scope.isAvailableTime(time);
        };
        $scope.active_calendar = $scope.calendars[activeIndex];
        $scope.setTime = function (time, label) {
            if (_.has($scope.too_late, time) || _.has($scope.stop_time, time)) {
                return false;
            }
            if (!$scope.isAvailableTime(time)) {
                if (waitlist !== 'Y') return false;
                if ($scope.waitlistFull(time)) return false;
                Booking.waitlist = true;
            } else {
                Booking.waitlist = false;
            }
            if (_.isUndefined(label)) {
                //try to find label
                var labels = $scope.getLabels(time);
                if (labels)
                    label = labels[0];
            }
            if (custom_length === false && _.has(seating_lengths, time)) {
                Booking.seating_length = seating_lengths[time];
            }
            Booking.isl = 'n';
            if (_.has(short_length_av, time)) {
                Booking.isl = 'y';
                Booking.ol = Booking.seating_length + '';
                Booking.seating_length = short_length_av[time];
            }
            Booking.setTime(time, label);//.then(function(r){
            //if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'Choose-time'}); }
            if (typeof (dataLayer) !== 'undefined') { dataLayer.push({ 'event': 'waiterAidMessage', 'message': { 'step': 'Choose-time' } }); }
            if (Booking.waitlist === true) {
                $state.go('waitlist-time', {}, { location: false });
            } else {
                if (_allow_temp && !settings.waitb) {
                    $scope.booking.temp_booking_id = 0;
                    $scope.booking.reserveTempBooking().success(function (response) {
                        if (response.success !== false && _.has(response, 'booking') && response.booking.id > 0) {
                            $scope.booking.temp_booking_id = response.booking.id;
                            $state.go('products', {}, { location: false });
                        } else {
                            _initTime();
                        }
                    });
                } else {
                    var lm = $scope.getLinkedMeals();
                    if (lm && lm.length > 0) {
                    } else {
                        $state.go('products', {}, { location: false });
                    }
                }
            }
        };
        $scope.isAutoWBS = function () {
            return settings.waitb && settings.waitb.length > 2;
        }
        $scope.setLinkedMealTime = function (time) {
            var chk = checkLinkedTime(time[1]);
            if (chk && chk[0] != true) return false;
            $scope.booking.setLinkedMeal(time[0]);
            //check if there is any more remaining linked meal
            $scope.booking.linked_meal = false;
            var lm = _.filter($scope.getLinkedMeals(), function (l) {
                var _lw = _.find($scope.booking.linked_meals, { id: l.id });
                return !_lw;
            });
            if (lm && lm.length > 0) {

            } else {
                $state.go('products', {}, { location: false });
            }
        }
        $scope.skipLinkedMeal = function () {
            $state.go('products', {}, { location: false });
        }
        $scope.$on("$viewContentLoaded", function () {
            $scope.booking.time = false;
        });

        $scope.isFullDate = function (date) {
            return _.includes($scope.getBlockedDates(), date.format("YYYY-MM-DD"));
        };
        $scope.calendar_next = function (e) {
            activeIndex++;
            //console.log($scope.calendars.length, index);
            if (activeIndex > $scope.calendars.length) activeIndex = $scope.calendars.length - 1;
            $scope.active_calendar = $scope.calendars[activeIndex];
        };
        $scope.calendar_prev = function (e) {
            //var activeIndex = getActiveCalendar();
            activeIndex--;
            if (activeIndex < 0) activeIndex = 0;
            $scope.active_calendar = $scope.calendars[activeIndex];
        };
        $scope.back = function () {
            resetList();
            $state.go('calendar', {}, { location: false });
        };
        $scope.addToWaitlist = function () {
            //if($scope.waitlistFull())
            $scope.booking.waitlist = true;
            $scope.checkWaitlist = false;
        };

        $scope.openLinkedTimeList = function (lm) {
            var tlrequest = {
                testmode: testmode,
                date_code: date_code,
                date: $scope.booking.getDate("YYYY-MM-DD"),
                amount: lm.amount ? lm.amount : $scope.booking.amount,
                mealid: lm.id,
                mc_code: $scope.booking.mc_code,
                lang: _widget_request.lang || '',
                hd_meal: _.has(_widget_request, 'hd_meal') ? _widget_request.hd_meal : (_.has($scope.alt_meal, 'hd') ? $scope.alt_meal.hd : ''),
                hash: hash,
                int_test: int_test
            };
            if ($scope.booking.seating_length && _.parseInt($scope.booking.seating_length) > 0) {
                tlrequest['length'] = $scope.booking.seating_length;
            }
            $http.post("/booking-widget/api/getTimes", tlrequest).success(function (response) {
                if (response.success === true) {
                    //lm.timelist = response.times;
                    var linkedM = _.find($scope.booking.linked_meals, { id: lm.id });
                    if (linkedM) {
                        linkedM.timelist = response.times;
                        $scope.booking.linked_meal = linkedM;
                    } else {
                        var lw = {
                            id: lm.id,
                            timelist: response.times,
                            name: lm.name,
                            amount: $scope.booking.amount,
                            time: '',
                            length_min: lm.length_min || $scope.booking.length_min
                        };
                        $scope.booking.linked_meals.push(lw);
                        $scope.booking.linked_meal = lw;
                    }
                }
            });
        };
        $scope.linkedMealAmountUp = function () {
            var lm = $scope.booking.linked_meal;
            $scope.booking.linkedMealAmountUp();
            $scope.openLinkedTimeList(lm);
        };
        $scope.linkedMealAmountDown = function () {
            var lm = $scope.booking.linked_meal;
            $scope.booking.linkedMealAmountDown();
            $scope.openLinkedTimeList(lm);
        };
        $scope.showingLinkedTimeList = function () {
            return $scope.booking.linked_meals.length > 0;
        };
        $scope.isAvailableLinkedBookTime = function (time, marginClass) {
            return checkLinkedTime(time, marginClass);
        };
        $scope.getLinkedMeals = function () {
            if (!_.has(settings, 'linked_meals')) return false;
            var links = _.filter(settings['linked_meals'], { meal_id: $scope.booking.meal.id });
            var linkedMeals = [];
            if (links) {
                _.forEach(links, function (link) {
                    var _m = _.find(meals, { id: link.linked_meal_id });
                    if (_m)
                        linkedMeals.push(_m);
                });
            }
            return linkedMeals;
        };
        $scope.isAvailableTime = function (time) {
            return _.find($scope.booking.last_timelist, function (t) {
                return t[0] === time;
            });
        };
        $scope.hasAvailableTime = function () {
            return _.size($scope.booking.last_timelist) > 0;
        };
        $scope.getLabels = function (time) {
            var lbl = _.has($scope.labels, time) ? $scope.labels[time] : [];
            if ($scope.booking.meal.ap_lbl_group == 1 && _.includes(lbl, $scope.activeLabel)) return [$scope.activeLabel];
            return lbl;
        };
        $scope.getTimelist = function () {
            return _.filter($scope.booking.last_timelist_full, function (t) {
                if ($scope.booking.meal.ap_lbl_group == 1 && _.size($scope.labelList) > 0) {
                    return _.has($scope.labels, t[0]) && _.includes($scope.labels[t[0]], $scope.activeLabel);
                }
                return $scope.isVisibleTime(t[0]);
            });
        };

        $scope.setActiveLabel = function (lbl, activeLblIndex) {
            $scope.activeLabel = lbl;
            $scope.activeLabelIndex = activeLblIndex;
        };
        $scope.getTimeFormat = function (t) {
            return moment.tgz(t * 1000).format('HH:mm');
        };
        function checkLinkedTime(time_to_check, marginClass) {
            var tt = $scope.booking.time.split(':');
            var te = $scope.booking.getEndTime('');
            te = te ? te.split(':') : false;
            var meal_name = $scope.booking.meal.name;
            var booking_time = moment.tgz($scope.booking.date).hours(tt[0]).minute(tt[1]).unix();
            //var tc = moment.tgz(booking_time*1000).format("HH:mm");
            var booking_end_time = te ? moment.tgz($scope.booking.date).hours(te[0]).minute(te[1]).unix() : 0;
            var min_length = $scope.booking.linked_meal.length_min ? $scope.booking.linked_meal.length_min : 0;
            min_length = min_length * 60;
            if (time_to_check <= booking_time || time_to_check >= booking_end_time) {
                for (let lm of $scope.booking.linked_meals) {
                    if (lm.time && lm.time !== '') {
                        var _tt = lm.time.split(':');
                        var _te = $scope.booking.getEndTime('', lm.time, lm.length_min);
                        _te = _te ? _te.split(':') : false;
                        var _booking_time = moment.tgz($scope.booking.date).hours(_tt[0]).minute(_tt[1]).unix();
                        var _booking_end_time = _te ? moment.tgz($scope.booking.date).hours(_te[0]).minute(_te[1]).unix() : 0;
                        var diff = lm.length_min * 60; //($scope.booking.seating_length || $scope.booking.linked_meal.length_min) * 60;
                        if (time_to_check < _booking_time && (time_to_check + diff) > _booking_time) return [marginClass, lm.name];
                        if ((time_to_check + diff) > _booking_time && time_to_check < _booking_end_time) return [false, lm.name];

                    }
                }
            }
            if (time_to_check < booking_time && (time_to_check + min_length) > booking_time) return [marginClass, meal_name];
            if ((time_to_check + min_length) > booking_time && time_to_check < booking_end_time) return [false, meal_name];
            return [true, meal_name];
        }
        $scope.getLinkedTimelist = function () {
            return $scope.booking.linked_meal.timelist;
        };

        function getActiveCalendar() {
            return _.findIndex($scope.calendars, function (calendar) {
                return !calendar.isNotSameMonth($scope.booking.date);
            });
        }
        function _initTime() {
            resetList();
            $scope.booking.temp_booking_id = 0;
            /*$http({
                method: 'POST',
                url: "/booking-widget/api/getTimes",
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                transformRequest: function(obj) {
                    var str = [];
                    for(var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data : {
                    testmode: testmode,
                    date_code: date_code,
                    date: $scope.booking.getDate("YYYY-MM-DD"),
                    amount: $scope.booking.amount,
                    mealid: $scope.booking.mealid,
                    hash: hash
                }
            }).success(function (response) {
                if (response.success !== true) {
                    alert(response.errors);
                    if (response.success !== true) return false;
                } else {
                    if (_.has(response, 'ap_labels'))
                        $scope.labels = response.ap_labels;
                    $scope.booking.last_timelist = response.times;
                    $scope.booking.last_timelist_full = response.full;
                    $scope.canSeeAlternateRests = response.alternate_rests;
                    $scope.canSeeNext30Days = response.future_availibility;

                }
            });*/


            $scope.labels = {};
            var trequest = {
                testmode: testmode,
                date_code: date_code,
                date: $scope.booking.getDate("YYYY-MM-DD"),
                amount: $scope.booking.amount,
                mealid: $scope.booking.mealid,
                mc_code: $scope.booking.mc_code,
                email: $scope.booking.email,
                hd_meal: _.has(_widget_request, 'hd_meal') ? _widget_request.hd_meal : (_.has($scope.alt_meal, 'hd') ? $scope.alt_meal.hd : ''),
                hash: hash,
                int_test: int_test,
                lang: _widget_request.lang || '',
            };
            if ($scope.booking.seating_length && _.parseInt($scope.booking.seating_length) > 0) {
                trequest['length'] = $scope.booking.seating_length;
            }
            waitlist_full = [];
            $scope.booking.waitlist_full = [];
            $scope.activeLabel = '';
            $scope.labelList = [];
            $scope.labelDescr = [];
            $http.post("/booking-widget/api/getTimes", trequest).success(function (response) {
                if (response.success !== true) {
                    alert(response.errors);
                    if (response.success !== true) return false;
                } else {
                    if (_.has(response, 'ap_labels')) {
                        $scope.activeLabelIndex = -1;
                        $scope.labels = response.ap_labels;
                        $scope.labelList = _.flatten(_.values(response.ap_labels));
                        $scope.labelList = _.uniq($scope.labelList);
                        $scope.activeLabel = $scope.labelList[0];
                        $scope.labelDescr = response.ap_label_descr;
                    }
                    var alt_m = settings.alternate_meals !== false && _.size(settings.alternate_meals) > 0 ? _.find(settings.alternate_meals, { from_mealid: $scope.booking.mealid }) : false;
                    if (alt_m) {
                        $scope.alt_meal = _.find(meals, { id: alt_m.to_mealid });
                    } else {
                        $scope.alt_meal = _.has(response, 'alt_meal') ? _.find(meals, { id: response.alt_meal }) : {};
                    }
                    if (!_.has($scope.alt_meal, 'id') && _.has(response, 'alt_meal_obj')) {
                        $scope.alt_meal = response.alt_meal_obj;
                    }
                    short_length_av = response.short_lengths;
                    $scope.booking.last_timelist = response.times;
                    $scope.booking.last_timelist_full = response.full;
                    $scope.canSeeAlternateRests = response.alternate_rests;
                    $scope.canSeeNext30Days = response.future_availibility;
                    $scope.full_text = response.full_text;
                    $scope.too_late = response.too_late;
                    waitlist_full = _.has(response, 'wl_full') ? response.wl_full : [];
                    $scope.booking.waitlist_full = waitlist_full;
                    $scope.stop_time = response.stop_time;
                    $scope.full_text_labels = response.full_text_labels;
                    if (_.has(response, 'lengths') && _.has(response.lengths, $scope.booking.mealid)) {
                        seating_lengths = response.lengths[$scope.booking.mealid];
                    }
                    if (_.has(_widget_request, 'time')) {
                        $scope.setTime(_widget_request.time);
                    }
                    $timeout(function () {
                        sendHeightEvent();

                    }, 300);

                    if (settings.newsletter_due_to_GDPR) {
                        $scope.booking.terms.restaurant = response.rest_newsletter;
                    }
                }
            });
        }
        //if(_.size($scope.getTimelist()) == 0)
        $scope.$on("$viewContentLoaded", function () {
            $timeout(function () {
                _.forEach(
                    document.querySelectorAll(".select-dropdown-container")
                    , function (el) {
                        if (el.classList.contains("disabled")) return;
                        _.forEach(el.querySelectorAll(".list"), function (lt) {
                            lt.addEventListener("click", function (e) {
                                console.log(e);
                                e.stopPropagation();
                            });
                        });
                        var lbl = el.querySelector('label');
                        lbl.addEventListener("click", function (e) {
                            e.stopPropagation();
                            if (el.classList.contains("show")) {
                                el.classList.remove("show");
                            } else {
                                hideDropDowns();
                                el.classList.add("show");
                            }
                        });
                    });
                $scope.setCalendars();
                updateWidgetStep('Timelist', { averageValue: $scope.booking.meal.avg_gtm_price, totalValue: ($scope.booking.meal.avg_gtm_price * $scope.booking.amount), meal: $scope.booking.meal.name, mealId: $scope.booking.meal.id, amount: $scope.booking.amount, date: $scope.booking.getDate('YYYY-MM-DD') });
                _initTime();
            }, 0);
        });
        $scope.getDescription = function (text) {
            return _.isObject(text) && _.has(text, $scope.langid) ? text[$scope.langid] : '';
            console.log("Yes");
        };
        var _days = moment.weekdaysShort();
        var sun_day = _days.shift(); //reset day names
        _days.push(sun_day); //reset day names//
        $scope.getAvailableDays = function (meal) {
            var disabled_days = [];
            if (_.size(_.compact(meal.days_disabled)) <= 0) return _days.join(', ');
            _.forEach(meal.days_disabled, function (d) {
                d = _.parseInt(d);
                if (_.isNaN(d)) return;
                disabled_days.push(d);
            });
            var available_days = [];
            _.forEach(_days, function (d, i) {
                if (!_.includes(disabled_days, i + 1))
                    available_days.push(d);
            });
            return available_days.join(', ');
        };
        function resetList() {
            meal_type = '';
            $scope.booking.time = false;
            $scope.booking.last_timelist = [];
            $scope.checkWaitlist = false;
            $scope.booking.last_timelist_full = [];
            $scope.booking.waitlist = false;
            $scope.canSeeAlternateRests = false;
            $scope.canSeeNext30Days = false;
            $scope.linked_timelist = [];
            $scope.booking.linked_meals = [];
            $scope.booking.linked_meal = false;
            //$scope.booking.checkForLinkedMeals();
        }
        $scope.checkAlternateRests = function () {
            var _types = { '1': 'Breakfast', '2': 'Lunch', '3': 'Dinner', '4': 'Fine Dining', '0': '' };
            window.open('https://www.bokabord.se/restauranger/' + $scope.booking.getDate('YYYY-MM-DD') + '/0/' + _types[$scope.booking.meal_type] + '/' + $scope.booking.amount + '/' + $scope.canSeeAlternateRests, '_name');
        };
        $scope.checkNext30Days = function () {
            window.open('http://www.bokabord.com' + $scope.canSeeNext30Days, '_name');
        };
        /** new **/


        $scope.setDate = function (date, calendar) {
            console.log(calendar, "is calendar");
            if (calendar.isOffDay(date)) { console.log("Off day"); return false; }
            if (calendar.isDisabled(date)) { console.log("disabled day"); return false; }
            if (calendar.isDisabledMonth(date)) { console.log("Disabled month"); return false; }
            $scope.booking.setDate(date.format("YYYY-MM-DD"));
            _initTime();
            hideDropDowns();
        };
        $scope.selectSeatingLength = function (seating) {
            custom_length = seating.len;
            $scope.booking.seating_length = seating.len;
            hideDropDowns();
            _initTime();
        };
        $scope.selectAmount = function (amount) {
            $scope.booking.amount = amount;
            $scope.setCalendars();
            _initTime();
            hideDropDowns();
            //if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'Choose-meal'}); }
            if (typeof (dataLayer) !== 'undefined') { dataLayer.push({ 'event': 'waiterAidMessage', 'message': { 'step': 'Choose-meal' } }); }
        };
        $scope.selectMeal = function (meal) {
            if (!meal.started) return false;
            $scope.booking.setMeal(meal);
            $scope.setCalendars();
            _initTime();
            hideDropDowns();
            //if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'Choose-meal'}); }
            if (typeof (dataLayer) !== 'undefined') { dataLayer.push({ 'event': 'waiterAidMessage', 'message': { 'step': 'Choose-meal' } }); }
        };

        function hideDropDowns() {
            _.forEach(
                document.querySelectorAll(".select-dropdown-container.show"),
                function (el) {
                    el.classList.remove("show");
                });
        }
        $document.on("click", hideDropDowns);
        $scope.$on("$destroy", function () {
            $document.off("click");
        });
        $scope.seating_time = allowSeatingTime();
        function allowSeatingTime() {
            var meal = $scope.booking.meal;
            if (!meal || !_.has(meal, 'id')) return false;
            if (meal.seating.allow !== true) return false;
            var available_times = meal.seating.time;
            if (!available_times || _.size(available_times) == 0) return false;
            var return_times = [];
            for (var x in available_times) {
                if (_.has($scope.seating_times, available_times[x])) {
                    return_times.push({ "len": available_times[x], "label": $scope.seating_times[available_times[x]] });
                } else if (!_.isUndefined(meal.mtrd)) {
                    let mtrd = meal.mtrd.split(';');
                    for (let tk in mtrd) {
                        let t = mtrd[tk].split('|');
                        if (t[0] == available_times[x]) {
                            return_times.push({ "len": available_times[x], "label": t[1] });
                        }
                    }
                }
            }
            return return_times.length > 0 ? return_times : false;
        }
        $scope.getLengthLabel = function () {
            var len = _.find($scope.seating_time, { len: $scope.booking.seating_length });
            return len ? len.label : false;
        };
        $scope.checkAlternateRests = function () {
            var _types = { '1': 'Breakfast', '2': 'Lunch', '3': 'Dinner', '4': 'Fine Dining', '0': '' };
            window.open('https://www.bokabord.se/restauranger/' + $scope.booking.getDate('YYYY-MM-DD') + '/0/' + _types[$scope.booking.meal_type] + '/' + $scope.booking.amount + '/' + $scope.canSeeAlternateRests, '_name');
        };

        var next_timelist_date = null;
        $scope.checkNext30Days = function () {
            if (next_timelist_date === null) {
                next_timelist_date = moment.tgz($scope.booking.date).date(1);
            }
            window.scrollTo(0, 0);
            $scope.next_availibility = [];
            $scope.time_view = 'next_timelist';
            var lastDay = next_timelist_date.daysInMonth();
            $http.post("/booking-widget/api/getNextTimeList", {
                from: next_timelist_date.format("YYYY-MM-DD"),
                to: next_timelist_date.format('YYYY-MM-' + (lastDay)),
                date: next_timelist_date.format('YYYY-MM-DD'),
                amount: Booking.amount,
                mealid: Booking.mealid,
                hd_meal: _.has(_widget_request, 'hd_meal') ? _widget_request.hd_meal : (_.has($scope.alt_meal, 'hd') ? $scope.alt_meal.hd : ''),
                hash: hash,
                date_code: date_code
            }).success(function (response) {
                $scope.next_availibility = [];
                if (_.has(response, 'times') && _.size(response.times) > 0) {
                    _.forEach(response.times, function (t, d) {
                        if (_.has(response, 'at') && _.has(response.at, d) && _.size(response.at[d]) > 0) {
                            var next_timelist_labels = [];
                            _.forEach(response.at[d], function (lbl, dt) {
                                next_timelist_labels.push(lbl);
                            });
                            next_timelist_labels = _.flatten(next_timelist_labels);
                            next_timelist_labels = _.uniq(next_timelist_labels);
                            var _times = {};
                            _.forEach(next_timelist_labels, function (tl) {
                                if (!_.has(_times, tl)) _times[tl] = [];
                                _.forEach(t, function (time) {
                                    if (!time.lbls || time.lbls.length == 0) {
                                        if (!_.has(_times, 'No Category')) _times['No Category'] = [];
                                        _times['No Category'].push(time);
                                    } else if (time.lbls && time.lbls.length > 0 && time.lbls.indexOf(tl) > -1) {
                                        _times[tl].push(time);
                                    }
                                });
                            });
                            $scope.next_availibility.push({ date: moment.tgz(d), with_labels: true, with_times: _.size(t) > 0, times: _times });
                        } else {
                            $scope.next_availibility.push({ date: moment.tgz(d), times: t });
                        }
                    });
                }
            });
            //window.open('http://www.bokabord.com' + $scope.canSeeNext30Days, '_name');
        };
        $scope._setTime = function (date, time, tracker, labels) {
            Booking.setDate(date);
            var lbl = _.size(labels) > 0 ? labels[0] : undefined;
            Booking.setTime(time, lbl);//.then(function(r){
            if (!_.isUndefined(tracker))
                from_url = tracker;
            //if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'Choose-date'}); }
            if (typeof (dataLayer) !== 'undefined') { dataLayer.push({ 'event': 'waiterAidMessage', 'message': { 'step': 'Choose-date' } }); }
            if (Booking.waitlist === true) {
                //$state.go('guest-details', {}, { location: false });
                $state.go('products', {}, { location: false });
            } else {
                $state.go('products', {}, { location: false });
            }
        };
        var last_bookable = moment.tgz().date(1).add(max_time, 'month');
        last_bookable.date(last_bookable.daysInMonth()).format('YYYY-MM-DD');
        var first_bookable = moment.tgz();

        $scope.canMove = function (dir) {
            if (dir === 'left') {
                //console.log("CL",_next_list_dates.from.format("YYYY-MM-DD") , '---', first_bookable.format("YYYY-MM-DD"));
                return next_timelist_date.isAfter(first_bookable, 'month');
            } else {
                return !moment.tgz(next_timelist_date).add(1, "month").isAfter(last_bookable, 'month');
            }
        };
        $scope.getPreviousMonthName = function () {
            return moment.tgz(next_timelist_date).subtract(1, "month").format("MMMM");
        };
        $scope.getNextMonthName = function () {
            return moment.tgz(next_timelist_date).add(1, "month").format("MMMM");
        };
        $scope.move_next_30days = function (dir) {
            //if(!$scope.canMove(dir)) return false;
            //console.log(_next_list_dates.from.format("YYYY-MM-DD") , '---', _next_list_dates.to.format("YYYY-MM-DD"));
            if (dir === 'left') {
                next_timelist_date.subtract(1, 'month');

            } else {
                next_timelist_date.add(1, 'month');
            }
            $scope.checkNext30Days();
            return;


            if (_next_list_dates.from.isBefore(first_bookable.format('YYYY-MM-DD'))) {
                _next_list_dates.from = moment.tgz(first_bookable);
                _next_list_dates.to = moment.tgz(_next_list_dates.from).add(1, 'month');
                //console.log('from is before today',_next_list_dates.from.format("YYYY-MM-DD") , '---', _next_list_dates.to.format("YYYY-MM-DD"));
            }

            if (_next_list_dates.to.isSameOrAfter(last_bookable)) {
                _next_list_dates.to = moment.tgz(last_bookable);
                //console.log('to is after last bookable date',_next_list_dates.from.format("YYYY-MM-DD") , '---', _next_list_dates.to.format("YYYY-MM-DD"));
            }
            $scope.checkNext30Days();
        };


    }
    angular.module("Waiteraid").controller("timeCtrl", timePageController);
})();
